// Analytics constants for the Copilot Code Review findings tab.
//
// Events are sent through `@github-ui/use-analytics` (`sendAnalyticsEvent`) and
// land in the Hydro browser-events pipeline (Kusto table
// `analytics_v0_browser_event`), auto-enriched with actor/repository/page
// context. The `FINDINGS_APP_NAME`/`FINDINGS_CATEGORY` values are surfaced as
// the `app`/`category` columns there, which the findings usage dashboard
// filters on. Keep the `event` type strings stable — dashboard queries depend
// on them.

export const FINDINGS_APP_NAME = 'copilot-findings'
export const FINDINGS_CATEGORY = 'findings'

interface FindingsAnalyticsEvent {
  type: string
  target: string
}

export const FINDINGS_ANALYTICS_EVENTS = {
  view: {type: 'findings.view', target: 'FINDINGS_TAB'},
  resolve: {type: 'findings.resolve', target: 'FINDINGS_RESOLVE'},
  reopen: {type: 'findings.reopen', target: 'FINDINGS_REOPEN'},
  fix: {type: 'findings.fix', target: 'FINDINGS_FIX'},
  filterChange: {type: 'findings.filter_change', target: 'FINDINGS_FILTER'},
  expand: {type: 'findings.expand', target: 'FINDINGS_EXPAND'},
} as const satisfies Record<string, FindingsAnalyticsEvent>
